import React from 'react';
import { ISVGType } from './SVGType';

const FailedToastIcon = (props: ISVGType) => {
  const { height = 62, width = 62, color= "#E75249" } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.2" cx="31" cy="31" r="13" fill="#14B2A9" />
      <circle opacity="0.2" cx="31.0009" cy="31" r="10.9032" fill="#14B2A9" />
      <circle opacity="0.2" cx="30.9992" cy="31" r="9.22581" fill="#14B2A9" />
      <g filter="url(#filter0_d_274_1174)">
        <circle cx="31" cy="31" r="18" fill={color} />
      </g>
      <g filter="url(#filter1_d_274_1174)">
        <path
          d="M29 22H32.6V32.8H29V22ZM30.8 36.4C31.31 36.4 31.7375 36.5725 32.0825 36.9175C32.4275 37.2625 32.6 37.69 32.6 38.2C32.6 38.71 32.4275 39.1375 32.0825 39.4825C31.7375 39.8275 31.31 40 30.8 40C30.29 40 29.8625 39.8275 29.5175 39.4825C29.1725 39.1375 29 38.71 29 38.2C29 37.69 29.1725 37.2625 29.5175 36.9175C29.8625 36.5725 30.29 36.4 30.8 36.4Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_274_1174"
          x="9"
          y="9"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset/>
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.905882 0 0 0 0 0.321569 0 0 0 0 0.286275 0 0 0 0.5 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_274_1174" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_274_1174" result="shape" />
        </filter>
        <filter
          id="filter1_d_274_1174"
          x="29"
          y="22"
          width="4.59961"
          height="19"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_274_1174" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_274_1174" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default FailedToastIcon;
